import { useState } from 'react';
// material
import { Select, MenuItem } from "@mui/material";
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
// ----------------------------------------------------------------------

const SORT_BY_OPTIONS = [
  { sortKey: "updatedAt", sortOrder: "-1", value: "Sort by", label: "Sort by" },
  { sortKey: "updatedAt", sortOrder: "-1", value: "updatedDesc", label: "Last updated (New first)" },
  { sortKey: "updatedAt", sortOrder: "1", value: "updatedAsc", label: "Last updated (Old first)" },
  { sortKey: "dashboardName", sortOrder: "1", value: "dashboardNameAsc", label: "Dashboard name (A-Z)" },
  { sortKey: "dashboardName", sortOrder: "-1", value: "dashboardNameDesc", label: "Dashboard name (Z-A)" }
];

export default function DashboardSort(props) {
  const { handleSort, className } = props
  const [sortValue, setSortValue] = useState(SORT_BY_OPTIONS[0].value);

  const handleChange = (event) => {
    let { value } = event.target
    handleSort(SORT_BY_OPTIONS.find(o => o.value === value))
    setSortValue(value)
  }

  return (
    <>
      <Select
        value={sortValue}
        onChange={(val) => handleChange(val)}
        autoWidth={false}
        className={className + " custom-select report-form-select"}
        IconComponent={DropDownIcon}
        MenuProps={{
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left"
          },
          transformOrigin: {
            vertical: "top",
            horizontal: "left"
          },
          getContentAnchorEl: null,
          classes:{
            root: `form-select-menu`,
          },
        }}
      >
        {SORT_BY_OPTIONS.map((option) => (
          <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
        ))}
      </Select>
    </>
  );
}
